module.exports = __webpack_public_path__ + "static/media/6S.800ab9ec.svg";